export default __webpack_public_path__ + "static/media/office1-before2-1920w.57d2c5e3.png";